import React, { useRef, useEffect } from 'react';
import Spinner from '../common/Spinner';
import { useController } from '@aha-app/mvc';
import { view } from '@aha-app/react-easy-state';
import CommandController from './controllers/CommandController';
import Modal from '@aha-app/react-bootstrap-modal';

const Command = () => {
  const controller = useController();
  const { firstCommand, outputs, phase } = controller.state;
  const doneButtonRef = useRef(null);

  useEffect(() => {
    if (phase === CommandController.PHASE_DONE) {
      doneButtonRef.current.focus();
    }
  }, [phase]);

  // TODO: when adding a new output probably need to scroll it into view.

  return (
    <div className='ask-fred'>
      <Modal.Header closeButton>
        <Modal.Title>{firstCommand.name}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className='command'>
          {outputs.map(output => (
            <div
              key={output.key}
              className='command__output'
              style={{ paddingLeft: 10 + 30 * output.depth }}
            >
              {output.render()}
            </div>
          ))}
          {phase === CommandController.PHASE_RUNNING && <Spinner />}
        </div>
      </Modal.Body>
      {phase === CommandController.PHASE_DONE && (
        <Modal.Footer>
          <button
            className='btn btn-primary'
            onClick={() => controller.actionClose()}
            ref={doneButtonRef}
          >
            Done
          </button>
        </Modal.Footer>
      )}
    </div>
  );
};

export default view(Command);
